import { getAvailableTimeSlots } from "../scoro/aggregateCalls";

export const getAvailableTimeSlotsRoute = async (user_id, duration, date) => {
  const data = await getAvailableTimeSlots(user_id, duration, date);
  return data;
};
